import { Flex } from '@smarterservices/smarter-ui';

import UserDetails from './User';
import CourseDetails from './CourseDetails';
import ExamDetails from './Exam';
import ProctorNotes from './ProctorNotes';
import StudentNotes from './StudentNotes';
import PermittedItems from './PermittedItems';
import ModalityOptions from './ModalityOptions';

const SessionInfo = () => {
  return (
    <Flex>
      <Flex.Item
        as="div"
        width="35%"
        align="start"
        padding="none small none none"
      >
        <ModalityOptions background="secondary" />
      </Flex.Item>
      <Flex.Item as="div" shouldGrow width="65%" align="start">
        <ExamDetails background="secondary" margin="none none small none" />
        <ProctorNotes background="secondary" margin="none none small none" />
        <PermittedItems background="secondary" margin="none none small none" />
        <StudentNotes background="secondary" />
      </Flex.Item>
    </Flex>
  );
};

export default SessionInfo;
